# Item Carousel

A horizontally scrollable row of cards for browsing collections.

## Install

```bash
npx aiapp-ui add item-carousel
```

## Usage

```tsx
import { ItemCarousel } from "@/components/aiapp-ui/item-carousel";

<ItemCarousel
  title="Recommended shows"
  items={[
    { id: "1", name: "The Wire", subtitle: "HBO · 2002", image: "/wire.jpg" },
    { id: "2", name: "Mad Men", subtitle: "AMC · 2007", image: "/madmen.jpg" },
    {
      id: "3",
      name: "Twin Peaks",
      subtitle: "ABC · 1990",
      image: "/peaks.jpg",
    },
  ]}
  onItemClick={(itemId) => console.log(itemId)}
/>;
```

**Role**: Information. For displaying collections that benefit from visual browsing. See [Design Guidelines](/docs/design-guidelines) for how component roles work.

## Props

| Prop           | Type                                         | Description                    |
| -------------- | -------------------------------------------- | ------------------------------ |
| `items`        | `Item[]`                                     | Array of items to display      |
| `title`        | `string?`                                    | Carousel heading               |
| `description`  | `string?`                                    | Optional description           |
| `onItemClick`  | `(itemId: string) => void`                   | Called when a card is clicked  |
| `onItemAction` | `(itemId: string, actionId: string) => void` | Called for card action buttons |

## Item schema

| Prop       | Type        | Description         |
| ---------- | ----------- | ------------------- |
| `id`       | `string`    | Unique identifier   |
| `name`     | `string`    | Card title          |
| `subtitle` | `string?`   | Secondary text      |
| `image`    | `string?`   | Image URL           |
| `actions`  | `Action[]?` | Card action buttons |

## Key features

- Equal-height cards via CSS Grid
- Smooth scroll with snap points and reduced-motion fallback
- Buttons stack or sit side-by-side based on card width via container queries
- Enter/Space activation, focus rings, and ARIA roles throughout
